module.exports = __webpack_public_path__ + "img/img3.46d7747d.png";